interface LoaderProps {
  isLoading: boolean
  loader: React.ComponentType
  children: React.ReactNode
}

export const Loader = ({ isLoading, loader: Loader, children }: LoaderProps) => {
  if (isLoading) return <Loader />

  return <>{children}</>
}
